import mir3Service from './mir3Service';

const announcementService = {
    getLoginPage: async ({ language, organizationId } = {}) => {
        const response = await mir3Service.getLoginPageAnnouncement(language, organizationId);
        const message = response?.responseJson?.text;

        if (response?.status === 200 && typeof message === 'string') {
            return { message };
        }

        return null;
    },
};

export default announcementService;
